export default {
      id: "crose-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#crose",
      toString: function () {
        return this.url;
      }
    }